module.exports = __webpack_public_path__ + "img/request_sended.fd99111d.png";